export default "__VITE_ASSET__CRi8wKxR__"